import { useFormContext } from 'react-hook-form'
import { Textarea } from '@/components/ui/textarea'
import { PostFormData } from '../types'

export function FormContentField() {
  const { register, formState } = useFormContext<PostFormData>()
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Conteúdo *</label>
      <Textarea
        {...register('content')}
        placeholder="Digite o conteúdo do post"
        rows={4}
        className="w-full"
      />
      {formState.errors.content && (
        <p className="text-sm text-red-500">{formState.errors.content.message}</p>
      )}
    </div>
  )
}
